import axiosInstance from './axios';

export interface ReportsData {
    ingresos: {
        total: number;
        efectivo: number;
        tarjeta: number;
        qr: number;
        variacion: number;
    };
    vehiculos: {
        total: number;
        carros: number;
        motos: number;
        promedio: number;
    };
    ocupacion: {
        actual: number;
        promedio: number;
        pico: number;
        valle: number;
    };
    operadores: Array<{
        nombre: string;
        vehiculos: number;
        ingresos: number;
        promedio: number;
        eficiencia: number;
    }>;
    contratos: any[]; // Define specific interface if needed
    auditoria: Array<{
        fecha: string;
        usuario: string;
        accion: string;
        modulo: string;
        estado: string;
    }>;
}

export const getReports = async (startDate: string, endDate: string, type?: string): Promise<ReportsData> => {
    const params = { startDate, endDate, type };
    const response = await axiosInstance.get<ReportsData>('/stats/reports', { params });
    return response.data;
};
